import CircleIcon from "@mui/icons-material/Circle";
import { Tooltip } from "@mui/material";

export default function DocumentStatusCell({ status, onDoubleClick,isPermission }) {
  const color =
    status === "GREEN" ? "#2e7d32" : status === "RED" ? "#d32f2f" : "#9e9e9e";

  return (
    <Tooltip title={status === "RED" && isPermission? "Double click to upload" : ""}>
      <CircleIcon
        sx={{ cursor: status === "RED" && isPermission ? "pointer" : "default", color }}
        onDoubleClick={onDoubleClick}
      />
    </Tooltip>
  );
}